import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import withSignalsManagement from "app/pages/sales-intelligence/sub-modules/signals/hoc/withSignalsManagement";

import { leadScoringSignalSourceExtractor } from "../utils/leadScoringSignalSourceExtractor";

import { ScoringSettingsPageContainer } from "./ScoringSettingsPageContainer";

const ScoringSettingsSignalsHandlerContainer = () => <ScoringSettingsPageContainer />;

export default withSecondaryBarSet("SalesIntelligenceLists")(
    withSignalsManagement(ScoringSettingsSignalsHandlerContainer, leadScoringSignalSourceExtractor),
);
